<template>
  <div class="refund-settings">
    <div class="page-header"><h2><span class="breadcrumb-level">订单管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">售后</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">售后设置</span></h2></div>
    <el-card>
      <template #header>      </template>
      <el-form :model="form" label-position="top" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="售后有效期(天)">
              <el-input-number v-model="form.after_sales_days" :min="0" :max="365" style="width:100%" />
              <div class="tip">订单完成后可申请售后的天数，0表示不允许售后</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="售后原因选项">
              <div class="reason-list">
                <div v-for="(r, i) in form.after_sales_reasons" :key="i" class="reason-item">
                  <el-input v-model="form.after_sales_reasons[i]" placeholder="输入售后原因" size="small" style="flex:1" />
                  <el-button type="danger" text size="small" @click="removeReason(i)">×</el-button>
                </div>
                <el-button size="small" @click="addReason">+ 添加原因</el-button>
              </div>
              <div class="tip">用户申请售后时可选择的原因列表</div>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-actions">
          <el-button @click="handleReset">重置</el-button>
          <el-button type="primary" @click="handleSubmit">保存设置</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import service from '../../api/axios'

const form = reactive({
  after_sales_days: 7,
  after_sales_reasons: ['商品破损', '商品与描述不符', '质量问题', '发错货', '其他']
})

const addReason = () => {
  form.after_sales_reasons.push('')
}

const removeReason = (index) => {
  form.after_sales_reasons.splice(index, 1)
}

const handleSubmit = async () => {
  try {
    await service({
      url: '/manage/settings/batch',
      method: 'post',
      data: {
        settings: {
          after_sales_days: {
            value: form.after_sales_days,
            type: 'number',
            description: '订单完成后可申请售后的天数'
          },
          after_sales_reasons: {
            value: form.after_sales_reasons,
            type: 'array',
            description: '售后原因选项'
          }
        }
      }
    })
    ElMessage.success('订单管理/售后/售后设置保存成功')
  } catch (e) {
    ElMessage.error('保存失败')
  }
}

const handleReset = () => {
  form.after_sales_days = 7
  form.after_sales_reasons = ['商品破损', '商品与描述不符', '质量问题', '发错货', '其他']
}
</script>

<style scoped>
.refund-settings {
}
.reason-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.reason-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  margin-top: 6px;
}
.form-actions {
  margin-top: 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
</style>
